import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionLabel from "./SectionLabel";

const CTAStartConversation = () => {
  return (
    <section
      data-testid="cta-start-conversation"
      className="relative py-32 md:py-40 border-t-2 border-black overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 architectural-grid opacity-50" />
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <SectionLabel className="mb-8" testid="label-cta">
          [ 07 ] - START
        </SectionLabel>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 0.61, 0.36, 1] }}
          viewport={{ once: true }}
          className="font-archivo font-black text-black h-tighter"
          style={{
            fontFamily: "Archivo, sans-serif",
            fontSize: "clamp(2.4rem, 9vw, 9rem)",
          }}
        >
          Start a
          <br />
          <span className="text-[#AE519F]">conversation.</span>
        </motion.h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <p
              className="text-black/70 text-base md:text-lg max-w-xl"
              style={{ fontFamily: "Outfit, sans-serif" }}
            >
              Whether you're building a brand from the ground up or
              restructuring an existing one - UPRCSE works across strategy,
              design, and execution to deliver complete solutions.
            </p>
          </div>
          <div className="md:col-span-5 md:flex md:justify-end">
            <Link
              to="/connect"
              data-testid="cta-conversation-link"
              className="liquid-btn is-primary inline-flex items-center gap-3"
            >
              Open a Conversation
              <ArrowUpRight size={16} strokeWidth={1.6} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTAStartConversation;
